
import React from 'react';
import { Tooltip, Divider, Grow } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { formatDecimalTime } from '../../util/common';

/**
 * A reusable tooltip component for displaying timesheet entry details.
 * Features a 1-second delay and a premium custom design.
 * 
 * @param {Array} entries - The list of time entries for the day.
 * @param {ReactNode} children - The element to wrap (the timesheet cell).
 */
const TimesheetTooltip = ({ entries, children }) => {
    if (!entries || entries.length === 0) {
        return children;
    }

    const renderTooltipContent = () => (
        <div className="timesheet-tooltip-content">
            <div className="tooltip-header">
                <AccessTimeIcon fontSize="small" /> Daily Breakdown
            </div>
            <Divider className="tooltip-divider" />
            {entries.map((entry, idx) => {
                const isSectionAttribution = entry.stageId && entry.stageId !== '';
                const isTaskAttribution = entry.taskId && entry.taskId !== '' && !isSectionAttribution;

                const sectionDisplay = isSectionAttribution
                    ? ((entry.sectionName || entry.taskName || 'No Section').replace(/ > /g, ' \\'))
                    : (isTaskAttribution
                        ? (entry.sectionName ? entry.sectionName.replace(/ > /g, ' \\') : 'No Section')
                        : 'No Section');

                const taskDisplay = isSectionAttribution
                    ? 'No Task'
                    : (isTaskAttribution
                        ? (entry.taskName || 'No Task')
                        : 'No Task');

                return (
                    <div key={idx} className="tooltip-entry-item">
                        <div className="entry-section-name">
                            Section: {sectionDisplay}
                        </div>
                        <div className="entry-task-name">
                            Task: {taskDisplay}
                        </div>
                        <div className="entry-hours-row">
                            <span>Total: {parseFloat(entry.regular || 0).toFixed(1)}h ({formatDecimalTime(entry.regular || 0)})</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );

    return (
        <Tooltip
            title={renderTooltipContent()}
            TransitionComponent={Grow}
            TransitionProps={{ timeout: 400 }}
            enterDelay={500}
            leaveDelay={200}
            interactive
            placement="bottom-start"
            classes={{ tooltip: 'custom-tooltip-bg' }}
        >
            {children}
        </Tooltip>
    );
};

export default TimesheetTooltip;
